import {
    Box,
    Button,
    CircularProgress,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Typography
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import React from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {formatImageUrl} from "../utils/utils";

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '20px',
        marginLeft: '25px',
        height: '80vh',
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        display: 'grid',
        margin: '15px',
        width: '95%',
        height: '-webkit-available'
    }
}));
export default function Map(props) {
    const classes = useStyles()
    const [loading, setLoading] = React.useState(false);
    const [display, setDisplay] = React.useState(null);
    const [selected_hotspot, setSelectedHotspot] = React.useState(0);
    const [visible, setVisible] = React.useState(false);
    let [html, setHtml] = React.useState([]);

    async function back() {
        props.setMap(false)
    }

    function closeModal() {
        let modal = document.getElementById('img_viewer')
        modal.hidden = true
    }

    function closeDialog() {
        setVisible(false)
    }

    function populateDialog(dialog, display) {
        /*   let flex = document.createElement('div')
           flex.setAttribute('class', 'flex')

           let title = document.createElement('div')
           title.setAttribute('class', 'display_title')
           title.textContent = display.name
   */


        /*    let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
            svg.setAttribute('xmlns', "http://www.w3.org/2000/svg")
            svg.setAttribute('class', "bi bi-chevron-down ")
            svg.setAttribute('viewBox', "0 0 16 16")
            svg.setAttribute('width', "80")
            svg.setAttribute('height', "80")
            svg.addEventListener('click', function (e) {
                let dialog = document.getElementById('dialog')
                dialog.classList.remove('animated')
                dialog.classList.add('hide')
                setTimeout(function () {

                    dialog.hidden = true
                    dialog.innerHTML = ''
                }, 200)
                e.stopImmediatePropagation()
            })

            let path = document.createElementNS("http://www.w3.org/2000/svg", 'path')
            path.setAttribute('fill-rule', "evenodd")
            path.setAttribute('d', "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z")

            //    down_arrow.appendChild(svg)
            //  flex.appendChild(title)
            //  flex.appendChild(down_arrow)
            //  svg.appendChild(path)
            //  dialog.appendChild(flex)


            if (display.hotspots.length > 1) {






                let dropdown = document.createElement('div')
                dropdown.setAttribute('class', 'dropdown')

                let button = document.createElement('button')
                button.setAttribute('class', 'btn btn-secondary dropdown-toggle my-select')
                button.setAttribute('type', 'button')
                button.setAttribute('id', 'dropdownMenuButton')
                button.setAttribute('data-toggle', 'dropdown')
                button.setAttribute('aria-haspopup', 'true')
                button.setAttribute('aria-expanded', 'false')
                button.textContent = display.hotspots[0].name
                let svg2 = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
                svg2.setAttribute('xmlns', "http://www.w3.org/2000/svg")
                svg2.setAttribute('class', "bi bi-chevron-down middle")
                svg2.setAttribute('viewBox', "0 0 16 16")
                svg2.setAttribute('width', "25")
                svg2.setAttribute('height', "25")


                let path2 = document.createElementNS("http://www.w3.org/2000/svg", 'path')
                path2.setAttribute('fill-rule', "evenodd")
                path2.setAttribute('d', "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z")

                svg2.appendChild(path2)
                let menu = document.createElement('div')
                menu.setAttribute('class', 'dropdown-menu my-menu')
                menu.setAttribute('aria-labelledby', 'dropdownMenuButton')

                display.hotspots.forEach(function callback(h, index) {

                    let a = document.createElement('a')
                    a.setAttribute('class', 'dropdown-item my-option')
                    a.setAttribute('href', 'javascript:setValue("' + h.name + '")')
                    a.textContent = h.name

                    menu.appendChild(a)
                });

                dropdown.appendChild(button)
                dropdown.appendChild(svg2)
                dropdown.appendChild(menu)

                dialog.appendChild(dropdown)
            }
            else {
                let div = document.createElement('div')
                div.setAttribute('class', 'hotspot_name gucci_text_bold')
                div.textContent = display.hotspots[0].name
                dialog.appendChild(div)
            }

            //product list
            let products_container = document.createElement('div')
            products_container.setAttribute('id', 'products_container')
            products_container.setAttribute('class', 'products_container')
            let selected_hotspot = 0
            if (display.hotspots.length > 1) {
                display.hotspots.forEach(function callback(h, index) {
                    if (h.name == document.getElementById('dropdownMenuButton').innerHTML) {
                        selected_hotspot = index;
                        index = display.hotspots.length
                    }
                })




            }
            if (display.hotspots[selected_hotspot]) {
                display.hotspots[selected_hotspot].products.forEach(function callback(h, index) {
                    let product = document.createElement('div')
                    product.setAttribute('class', 'product')
                    products_container.appendChild(product)

                    let img_style = " height: 100px;    width: 108px;    align-self: center;    background-color: white;    margin-right: 20px;    background-repeat: no-repeat;    background-size: contain;background-image:url('" + h.imageLink + ');'
                    let img = document.createElement('div')
                    img.setAttribute('class', 'product_img')
                    img.setAttribute('style', img_style)
                    img.addEventListener('click', function () {
                        let viewer = document.getElementById('img_viewer')
                        let image = document.getElementById('image')
                        image.style.backgroundImage = 'url(' + h.imageLink + ')'
                        viewer.hidden = false
                        let dialog = document.getElementById('dialog')
                        dialog.classList.remove('animated')
                        dialog.classList.add('hide')
                        dialog.hidden = true
                    })
                    product.appendChild(img)

                    let details = document.createElement('div')
                    details.setAttribute('class', 'product_details')

                    let smc = document.createElement('div')
                    smc.setAttribute('class', 'product_smc')
                    smc.textContent = 'SMC:' + h.smc

                    let sku = document.createElement('div')
                    sku.setAttribute('class', 'product_sku')
                    sku.textContent = 'SKU:' + h.sku

                    let name = document.createElement('div')
                    name.setAttribute('class', 'product_name')
                    name.textContent = 'Name:' + h.name

                    let position = document.createElement('div')
                    position.setAttribute('class', 'product_position')
                    position.textContent = 'Position:' + h.position

                    details.appendChild(smc)
                    details.appendChild(sku)
                    details.appendChild(name)
                    details.appendChild(position)

                    product.appendChild(details)
                })
            }

            dialog.appendChild(products_container)
    */
    }


    function getProducts() {

        let products = ''
        /*  if (display.hotspots.length > 1) {
              display.hotspots.map((h, index) => {
                  if (h.name == document.getElementById('hotspot_name').innerHTML) {
                      selected_hotspot = index;
                      index = display.hotspots.length
                  }
              })

          }*/
        if (display.hotspots[selected_hotspot]) {
            products = display.hotspots[selected_hotspot].products.map((h, index) =>

                <div className="product">
                    <div onClick={() => showImage(h)} className="product_img" style={{
                        height: "100px",
                        width: "108px",
                        alignSelf: "center",
                        backgroundColor: "white",
                        marginRight: "20px",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundImage: "url('" + formatImageUrl(h.imageLink) + ".jpeg')"
                    }}>

                    < /div>
                    <div className='product_details'>
                        <div className="product_smc">{h.smc}
                        </div>
                        <div className="product_sku">{h.sku}</div>
                        <div className="product_name">{h.name}</div>
                        <div className="product_position">{h.position}</div>
                    </div>
                </div>
            )
        }


        return products;


    }

    function showImage(h) {

        let viewer = document.getElementById('img_viewer')
        let image = document.getElementById('image')
        image.style.backgroundImage = 'url(' + formatImageUrl(h.imageLink) + ')'
        viewer.hidden = false
        // setVisible(false)

    }

    function openDialog(display) {
        setVisible(true)
        setSelectedHotspot(0)
        setDisplay(display)
        //  populateDialog(dialog, display)

    }

    function handleChange(e) {
        setSelectedHotspot(e.target.value)
    }

    function search(event) {
        props.setLoading(true)
        setHtml([])
        getDisplays(event.target.value)
    }

    async function getDisplays(val) {


        let my_displays = []
        html = my_displays
        my_displays = props.displays.filter(function (item) {
            return item.posX && item.posX;
        })
        let width = props.selectedEvent.width
        let height = props.selectedEvent.height


        my_displays.map((display, index) => {
            let top = (display.posY * 100) / height;
            let left = (display.posX * 100) / width;

            //let style = {" top: " + top + "%; left: " + left + '%;' + 'background-image:url("https://exotic.wwmis.gucci/showroom/' + display.imageLink + '.jpeg"); width:35px; height:35px'
            let style = {
                "top": top + "%",
                'left': left + '%',
                backgroundImage: 'url("' + display.imageLink200 + '")',
                'width': '22px',
                'height': '22px',
            }
            let added = false
            if (display.name.toLowerCase().includes(val.toLowerCase()) || val === '') {
                html.push(<div className="display" key={display.id} style={style}
                               onClick={() => openDialog(display)}></div>)
                added = true
            }
            if (!added) {
                display.hotspots.map((hotspot) => {
                    if (hotspot.name.toLowerCase().includes(val.toLowerCase())) {
                        html.push(<div className="display" key={display.id} style={style}
                                       onClick={() => openDialog(display)}></div>)
                        added = true
                    }
                });
            }
            if (!added) {
                display.hotspots.forEach(function callback(hotspot, index) {
                    hotspot.products.forEach(function callback(product) {

                        if (product.name.toLowerCase().includes(val.toLowerCase()) && !added) {
                            html.push(<div className="display" key={display.id} style={style}
                                           onClick={() => openDialog(display)}></div>)
                            added = true
                            index = display.hotspots.length
                        } else if (product.smc.toLowerCase().includes(val.toLowerCase()) && !added) {
                            html.push(<div className="display" key={display.id} style={style}
                                           onClick={() => openDialog(display)}></div>)
                            added = true
                            index = display.hotspots.length
                        }
                    })
                })
                /* if (!added) {
                    display.hotspots.forEach(function callback(hotspot) {
                        hotspot.products.map((product) => {
                            if (product.name.toLowerCase().includes(val)) {
                                html.push(<div className="display" key={display.id} style={style} onClick={() => openDialog(display)}> </div>)
                                added = true
                            } else if (product.smc.toLowerCase().includes(val)) {
                                html.push(<div className="display" key={display.id} style={style} onClick={() => openDialog(display)}> </div>)
                                added = true
                            }
                        })
                    });
                }*/
            }

        });
        setHtml(html)
        setLoading(false)

    }

    React.useEffect(() => {
            props.setLoading(true)
            setHtml([])
            getDisplays('')

        }, [props.selectedEvent, props.displays, loading]
    )

    return (
        <div>
            <div className={classes.root}>
                {loading ?
                    <div style={{textAlign: 'center'}}>
                        <Typography style={{paddingBottom: '20px'}} variant="h6">Loading...</Typography>
                        <CircularProgress/>
                    </div>
                    :
                    <div>
                        <Grid item xs={2} className="ml-20">
                            <Button className='red template_button pl-15'
                                    startIcon={<ArrowBackIosNewIcon color='error'/>} onClick={() => back()}>
                                <div className='gucci_text_bold ml-8 '> Back</div>
                            </Button>
                        </Grid>
                    </div>}

                {props.selectedEvent.imageUrl ?
                    <div className="map_container ">
                        <div className="search-container">
                            <input autoComplete='off' id='search-text' className='input-button'
                                   placeholder="Search by SMC, name, hotspot"
                                   onInput={(e) => search(e)}/>
                            <svg version="1.1" xlink="http://www.w3.org/1999/xlink" width="25" height="25"
                                 xmlns="http://www.w3.org/2000/svg" className="search_icon_svg">
                                <g transform="matrix(1 0 0 1 -277 -27 )">
                                    <path
                                        d="M 11.0390625 11.0390625  C 11.9873798076923 10.0907451923077  12.4615384615385 8.94951923076923  12.4615384615385 7.61538461538462  C 12.4615384615385 6.28125  11.9873798076923 5.14002403846154  11.0390625 4.19170673076923  C 10.0907451923077 3.24338942307692  8.94951923076923 2.76923076923077  7.61538461538461 2.76923076923077  C 6.28125 2.76923076923077  5.14002403846154 3.24338942307692  4.19170673076923 4.19170673076923  C 3.24338942307692 5.14002403846154  2.76923076923077 6.28125  2.76923076923077 7.61538461538462  C 2.76923076923077 8.94951923076923  3.24338942307692 10.0907451923077  4.19170673076923 11.0390625  C 5.14002403846154 11.9873798076923  6.28125 12.4615384615385  7.61538461538461 12.4615384615385  C 8.94951923076923 12.4615384615385  10.0907451923077 11.9873798076923  11.0390625 11.0390625  Z M 17.5997596153846 15.6418269230769  C 17.8665865384615 15.9086538461538  18 16.2331730769231  18 16.6153846153846  C 18 16.9903846153846  17.8629807692308 17.3149038461538  17.5889423076923 17.5889423076923  C 17.3149038461538 17.8629807692308  16.9903846153846 18  16.6153846153846 18  C 16.2259615384615 18  15.9014423076923 17.8629807692308  15.6418269230769 17.5889423076923  L 11.9314903846154 13.8894230769231  C 10.640625 14.7836538461538  9.20192307692308 15.2307692307692  7.61538461538461 15.2307692307692  C 6.58413461538462 15.2307692307692  5.59795673076923 15.0306490384615  4.65685096153846 14.6304086538462  C 3.71574519230769 14.2301682692308  2.90444711538462 13.6893028846154  2.22295673076923 13.0078125  C 1.54146634615385 12.3263221153846  1.00060096153846 11.5150240384615  0.600360576923077 10.5739182692308  C 0.200120192307692 9.6328125  0 8.64663461538461  0 7.61538461538462  C 0 6.58413461538461  0.200120192307692 5.59795673076923  0.600360576923077 4.65685096153846  C 1.00060096153846 3.71574519230769  1.54146634615385 2.90444711538462  2.22295673076923 2.22295673076923  C 2.90444711538462 1.54146634615385  3.71574519230769 1.00060096153846  4.65685096153846 0.600360576923078  C 5.59795673076923 0.200120192307692  6.58413461538462 0  7.61538461538461 0  C 8.64663461538461 0  9.6328125 0.200120192307692  10.5739182692308 0.600360576923078  C 11.5150240384615 1.00060096153846  12.3263221153846 1.54146634615385  13.0078125 2.22295673076923  C 13.6893028846154 2.90444711538462  14.2301682692308 3.71574519230769  14.6304086538462 4.65685096153846  C 15.0306490384615 5.59795673076923  15.2307692307692 6.58413461538461  15.2307692307692 7.61538461538462  C 15.2307692307692 9.20192307692308  14.7836538461538 10.640625  13.8894230769231 11.9314903846154  L 17.5997596153846 15.6418269230769  Z "
                                        fillRule="nonzero" fill="#000000" stroke="none"
                                        transform="matrix(1 0 0 1 277 27 )"/>
                                </g>
                            </svg>
                        </div>
                        <div className="imageMap">
                            <TransformWrapper>
                                {({zoomIn, zoomOut, ...rest}) => (

                                    <React.Fragment>
                                        <div className="tools">
                                            <svg onClick={() => zoomIn()} xmlns="http://www.w3.org/2000/svg"
                                                 width="22" height="22" fill="currentColor"
                                                 className="bi bi-plus-circle mb-1 pointer" viewBox="0 0 16 16">
                                                <path
                                                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
                                                <path
                                                    d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"></path>
                                            </svg>
                                            <svg onClick={() => zoomOut()} xmlns="http://www.w3.org/2000/svg"
                                                 width="22" height="22" fill="currentColor"
                                                 className="bi bi-dash-circle pointer" viewBox="0 0 16 16">
                                                <path
                                                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
                                                <path
                                                    d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"></path>
                                            </svg>
                                        </div>
                                        <TransformComponent>
                                            <div className="image_container_map">

                                                <img src={props.selectedEvent.imageUrl} width="100%"
                                                     className="image"/>
                                                <div className="displays">
                                                    {html}
                                                </div>
                                            </div>
                                        </TransformComponent>

                                    </React.Fragment>

                                )}
                            </TransformWrapper>
                        </div>
                    </div>
                    : <div className="gucci_text mt-20 text_center"> No map for this event</div>}

            </div>
            {visible ? <div className="animated" id='dialog'>
                    {display ?
                        <div className="flex">
                            <div className="display_title">{display.name}</div>

                            <div className="down_arrow" onClick={() => closeDialog()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor"
                                     className="bi bi-chevron-down middle" viewBox="0 0 16 16">
                                    <path fillRule="evenodd"
                                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                </svg>
                            </div>
                        </div>
                        : ''}
                    {display.hotspots.length > 1 ?
                        <div className="select_hotspot">

                            < Box sx='30'>
                                <FormControl fullWidth>
                                    <InputLabel className="event_demo"
                                                id="demo-simple-select-label gucci-text">Hotspot</InputLabel>
                                    <Select
                                        style={{
                                            right: "20px",
                                            color: "black"
                                        }}
                                        value={selected_hotspot}
                                        label={display.hotspots[selected_hotspot].name}
                                        onChange={handleChange}
                                    >
                                        {display.hotspots.length > 0 ?
                                            display.hotspots.map((h, index) => (
                                                <MenuItem value={index} className="gucci-text">{h.name}</MenuItem>
                                            ))
                                            :
                                            <MenuItem value='-1' className="gucci-text">No events</MenuItem>
                                        }
                                    </Select>
                                </FormControl>
                            </Box>

                        </div>
                        :
                        <div
                            className="hotspot_name gucci_text_bold"> {display.hotspots.length > 0 ? display.hotspots[0].name : ''}</div>
                    }
                    <div id='products_container' className="products_container">


                        {visible ? getProducts() : ''}

                    </div>


                </div>

                : ''
            }


            <div id="img_viewer" hidden>
                <div onClick={() => closeModal()}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120"
                         fill="currentColor" className="bi bi-x close_modal" viewBox="0 0 16 16">
                        <path
                            d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </div>

                <div id='image'>
                </div>
            </div>
        </div>
    )
}

{/*     <div id='hotspot_name' className="hotspot_name gucci_text_bold">
            dropdown</div> */
}
